import { Toaster } from "sonner";

import styles from "../snackbar-toaster/SnackbarToaster.module.css";

export const NOTIFICATION_TOASTER_ID = "notification";

export const NotificationToaster = () => (
  <Toaster
    id={NOTIFICATION_TOASTER_ID}
    position="top-right"
    theme="dark"
    gap={8}
    toastOptions={{ className: styles.wrapper }}
  />
);
